import apiClient from '@/services/api/apiClient';

export default {
  getTable: (payload) => apiClient.get('/planning/', { params: payload }),
  postWorkLoad: (payload) => apiClient.post('/workload/', payload),
  postProjectForUser: (payload) => apiClient.post('/workload_project/', payload),
  postProjectForAbstract: (payload) => apiClient.post('/project_abstract/', payload),
  deleteEmployee: (payload) => apiClient.delete(`/workload/${payload.user_id}/`, { data: payload }),
};
